export default "__VITE_ASSET__ky0pL7x0cTOKQo35PFl23A__"